module.exports = __webpack_public_path__ + "img/illus_22.1ade7ecc.png";